import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setFormValue } from 'redux/modules/newClient';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Tooltip } from 'components';
import * as styles from './NewLocation.scss';
var NewLocationFormStep1 = (_dec = connect(function (state) {
  return {
    savedBillingConfig: state.organization.orgBillingConfig,
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  setFormValue: setFormValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewLocationFormStep1, _Component);

  var _super = _createSuper(NewLocationFormStep1);

  function NewLocationFormStep1(props) {
    var _this;

    _classCallCheck(this, NewLocationFormStep1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextFieldChange", function (e, val) {
      _this.props.setFormValue(e.target.id, e.target.id === 'businessName' ? 'orgDetails' : 'orgConfig', val);

      if (e.target.id === 'businessName') {
        _this.validateLocationName(val);
      }

      if (e.target.id === 'adsBudget') {
        _this.validateAdsBudget(val);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateAdsBudget", function (val) {
      if (parseInt(val, 10) !== 0 && isNaN(parseInt(val, 10))) {
        _this.setState({
          adsBudgetErrorText: 'Must be a 0 or more.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else if (val === '') {
        _this.setState({
          adsBudgetErrorText: 'Must be 0 or more.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else if (_this.props.edit && parseInt(val) === parseInt(_this.props.savedBillingConfig.adsBudget)) {
        _this.setState({
          adsBudgetErrorText: 'Please change the ads budget'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else {
        _this.setState({
          adsBudgetErrorText: ''
        });

        _this.props.setFormValue('step1Valid', 'validation', true);

        _this.validateLocationName(_this.props.formValues.orgDetails.businessName);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateLocationName", function (val) {
      if (val === '') {
        _this.setState({
          locationNameErrorText: 'Location name cannot be blank.'
        });

        _this.props.setFormValue('step1Valid', 'validation', false);
      } else {
        _this.setState({
          locationNameErrorText: ''
        });

        _this.props.setFormValue('step1Valid', 'validation', true);
      }
    });

    _this.state = {
      adsBudgetErrorText: '',
      managementFeeErrorText: '',
      currentAdsBudget: props.savedBillingConfig && props.savedBillingConfig.adsBudget ? parseInt(props.savedBillingConfig.adsBudget) : 0
    };

    if (props.edit) {
      props.setFormValue('adsBudget', 'orgConfig', props.savedBillingConfig && props.savedBillingConfig.adsBudget ? parseInt(props.savedBillingConfig.adsBudget) * 2 : 0);
      props.setFormValue('managementFee', 'orgConfig', props.savedBillingConfig.managementFee);
      props.setFormValue('billingMethod', 'orgConfig', props.savedBillingConfig.billingMethod);
      props.setFormValue('managementMethod', 'orgConfig', props.savedBillingConfig.managementMethod);
    }

    return _this;
  }
  /** *********************************************************
   CUSTOM METHODS
   ***********************************************************/


  _createClass(NewLocationFormStep1, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          edit = _this$props.edit,
          formValues = _this$props.formValues;
      var hasExistingLicenses = contractInfo && contractInfo.totals && contractInfo.totals.clientsUsed < contractInfo.totals.clientsPermitted;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      var newLocationName = formValues && formValues.orgDetails.businessName && formValues.orgDetails.businessName !== '' ? formValues.orgDetails.businessName : 'New Location';
      return /*#__PURE__*/React.createElement("div", null, !this.props.edit && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "Location Information"), /*#__PURE__*/React.createElement(TextField, {
        floatingLabelText: "Location Name",
        errorText: this.state.locationNameErrorText,
        hintText: "Location Name",
        id: "businessName",
        value: this.props.formValues.orgDetails.businessName,
        onChange: this.handleTextFieldChange
      })), !this.props.edit && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle
      }, "License Fee"), hasExistingLicenses && /*#__PURE__*/React.createElement(Checkbox, {
        label: "Use Existing License (".concat(parseInt(contractInfo.totals.clientsPermitted) - parseInt(contractInfo.totals.clientsUsed), " available)"),
        style: {
          marginBottom: 16
        },
        checked: formValues.locationBillingInfo.licenseFeeBillTo === 'existing',
        onCheck: function onCheck(e, val) {
          _this2.props.setFormValue('licenseFeeBillTo', 'locationBillingInfo', formValues.locationBillingInfo.licenseFeeBillTo === 'existing' ? 'partner' : 'existing');
        }
      }), formValues.locationBillingInfo.licenseFeeBillTo !== 'existing' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333333',
          marginBottom: 4
        }
      }, "Bill $", this.props.formValues.orgConfig.managementFee, "/mo fee to:"), /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "locationBillingInfo",
        defaultSelected: this.props.formValues.locationBillingInfo.licenseFeeBillTo,
        onChange: function onChange(e, val) {
          _this2.props.setFormValue('licenseFeeBillTo', 'locationBillingInfo', val);
        }
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: "partner",
        label: partnerName,
        style: {
          marginBottom: 4
        }
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "location",
        label: newLocationName
      })))), this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement("section", {
        className: styles.formSection,
        style: {
          marginTop: 32
        }
      }, this.props.edit && /*#__PURE__*/React.createElement("div", {
        className: styles.editOldTotalWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.editOldTotalSpan
      }, "Current monthly ads budget: ", this.formatCurrency(this.state.currentAdsBudget))), /*#__PURE__*/React.createElement("h2", {
        className: styles.formSectionTitle,
        style: {
          marginBottom: 0,
          marginTop: 24
        }
      }, "Ads Amount"), /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: 4
        }
      }, "$"), /*#__PURE__*/React.createElement(TextField, {
        errorText: this.state.adsBudgetErrorText,
        floatingLabelText: "Monthly Ads Budget",
        hintText: "Monthly Ads Budget",
        id: "adsBudget",
        value: this.props.formValues.orgConfig.adsBudget,
        onChange: this.handleTextFieldChange
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 8
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333333',
          marginBottom: 4
        }
      }, "Bill to:"), /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "locationBillingInfo_ads",
        defaultSelected: this.props.formValues.locationBillingInfo.adsBillTo,
        onChange: function onChange(e, val) {
          _this2.props.setFormValue('adsBillTo', 'locationBillingInfo', val);
        }
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: "partner",
        label: partnerName,
        style: {
          marginBottom: 4
        }
      }), /*#__PURE__*/React.createElement(RadioButton, {
        value: "location",
        label: newLocationName
      })))));
    }
  }]);

  return NewLocationFormStep1;
}(Component)) || _class);
export { NewLocationFormStep1 as default };